(() => {
  const WRAP_SELECTOR = '.contact-figma__select-wrap';
  const CONSENT_ROW_SELECTOR = '.contact-figma__consent-row';
  const OPEN_CLASS = 'is-open';
  const ENHANCED_CLASS = 'is-enhanced';

  const getParts = (wrap) => ({
    nativeSelect: wrap.querySelector('[data-contact-subject-native]'),
    toggle: wrap.querySelector('[data-contact-subject-toggle]'),
    panel: wrap.querySelector('[data-contact-subject-panel]'),
    current: wrap.querySelector('[data-contact-subject-current]'),
    options: Array.from(wrap.querySelectorAll('[data-contact-subject-option]')),
  });

  const closeDropdown = (wrap) => {
    const { toggle, panel } = getParts(wrap);
    if (!toggle || !panel) return;

    wrap.classList.remove(OPEN_CLASS);
    toggle.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
  };

  const closeOtherDropdowns = (currentWrap) => {
    document.querySelectorAll(`${WRAP_SELECTOR}.${OPEN_CLASS}`).forEach((wrap) => {
      if (wrap !== currentWrap) closeDropdown(wrap);
    });
  };

  const openDropdown = (wrap) => {
    const { toggle, panel, options } = getParts(wrap);
    if (!toggle || !panel || !options.length) return;

    closeOtherDropdowns(wrap);
    wrap.classList.add(OPEN_CLASS);
    toggle.setAttribute('aria-expanded', 'true');
    panel.hidden = false;

    const selectedOption = options.find((option) => option.classList.contains('is-selected'));
    (selectedOption || options[0]).focus({ preventScroll: true });
  };

  const syncSelectedOption = (wrap, value) => {
    const { current, options } = getParts(wrap);

    options.forEach((option) => {
      const isSelected = option.getAttribute('data-subject-value') === value;
      option.classList.toggle('is-selected', isSelected);
      option.setAttribute('aria-selected', isSelected ? 'true' : 'false');

      if (isSelected && current) {
        current.textContent = option.textContent.trim();
      }
    });
  };

  const selectOption = (wrap, option) => {
    const { nativeSelect, toggle } = getParts(wrap);
    const value = option.getAttribute('data-subject-value') || '';

    if (nativeSelect) {
      nativeSelect.value = value;
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    syncSelectedOption(wrap, value);
    closeDropdown(wrap);
    toggle?.focus({ preventScroll: true });
  };

  const enhanceWrap = (wrap) => {
    if (wrap.classList.contains(ENHANCED_CLASS)) return;

    const { nativeSelect, toggle, panel, options } = getParts(wrap);
    if (!nativeSelect || !toggle || !panel || !options.length) return;

    wrap.classList.add(ENHANCED_CLASS);
    closeDropdown(wrap);

    if (nativeSelect.value) {
      syncSelectedOption(wrap, nativeSelect.value);
    }

    nativeSelect.addEventListener('change', () => {
      syncSelectedOption(wrap, nativeSelect.value);
      if (nativeSelect.validity.valid) toggle.removeAttribute('aria-invalid');
    });

    nativeSelect.addEventListener('invalid', (event) => {
      event.preventDefault();
      toggle.setAttribute('aria-invalid', 'true');
      openDropdown(wrap);
    });
  };

  const init = (root = document) => {
    root.querySelectorAll(WRAP_SELECTOR).forEach(enhanceWrap);
  };

  document.addEventListener('click', (event) => {
    const consentRow = event.target.closest(CONSENT_ROW_SELECTOR);
    const handledByNativeControl = event.target.closest('a, button, input, label, select, textarea');

    if (consentRow && !handledByNativeControl) {
      const input = consentRow.querySelector('.contact-figma__checkbox-input');
      input?.click();
      return;
    }

    const toggle = event.target.closest('[data-contact-subject-toggle]');
    if (toggle) {
      const wrap = toggle.closest(WRAP_SELECTOR);
      if (!wrap) return;

      event.preventDefault();
      if (wrap.classList.contains(OPEN_CLASS)) {
        closeDropdown(wrap);
      } else {
        openDropdown(wrap);
      }
      return;
    }

    const option = event.target.closest('[data-contact-subject-option]');
    if (option) {
      const wrap = option.closest(WRAP_SELECTOR);
      if (!wrap) return;

      event.preventDefault();
      selectOption(wrap, option);
      return;
    }

    closeOtherDropdowns(null);
  });

  document.addEventListener('keydown', (event) => {
    const wrap = event.target.closest(WRAP_SELECTOR);
    if (!wrap) return;

    const { options } = getParts(wrap);
    const currentIndex = options.indexOf(document.activeElement);

    if (event.key === 'Escape') {
      event.preventDefault();
      closeDropdown(wrap);
      getParts(wrap).toggle?.focus({ preventScroll: true });
      return;
    }

    if (event.target.matches('[data-contact-subject-toggle]') && ['ArrowDown', 'Enter', ' '].includes(event.key)) {
      event.preventDefault();
      openDropdown(wrap);
      return;
    }

    if (!wrap.classList.contains(OPEN_CLASS) || currentIndex === -1) return;

    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      const direction = event.key === 'ArrowDown' ? 1 : -1;
      const nextIndex = (currentIndex + direction + options.length) % options.length;
      options[nextIndex]?.focus({ preventScroll: true });
      return;
    }

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      selectOption(wrap, document.activeElement);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
